import {publishEvent} from '../pub-sub';
import {ANALYTIC_EVENTS} from '../pub-sub/constants';

export const LogoutTracker = {
  userAction: () => publishEvent(ANALYTIC_EVENTS.LOGOUT_BY_USER),
  systemAction: () => publishEvent(ANALYTIC_EVENTS.LOGOUT_BY_SYSTEM)
};
